/* istanbul ignore file */
// libs
import React from 'react';
// components
import { Show } from 'framework/show';
// services
import useContactService from 'domain/sales/contact/shared/contactService';
import { useContactId } from 'domain/sales/contact/contactRouting';

const ShowContact = ({ children = null }: { children?: React.ReactNode }) => {
  const id = useContactId();
  const { getById } = useContactService();

  return <Show getDataMethod={() => getById(id)}>{children}</Show>;
};

export default ShowContact;
